<template>
  <div class="videoCate">
    <h3>国匠酒业 订单管理</h3>
    <div style="margin-top: 15px;">
      <el-select class="search-select" v-model="params.keywordType" @change="searchlist">
        <el-option value="1" label="按订单号搜索" :key="0"></el-option>
        <el-option value="2" label="按用户昵称搜索" :key="1"></el-option>
        <el-option value="4" label="按分销员搜索" :key="4"></el-option>
        <!-- <el-option value="3" label="按患者名字搜索" :key="2"></el-option>
        <el-option value="4" label="按医生名字搜索" :key="3"></el-option>
        <el-option value="5" label="按业务员名字搜索" :key="4"></el-option> -->
        <el-option value="6" label="按收货人名字搜索" :key="5"></el-option>
        <el-option value="7" label="按产品简称搜索" :key="6"></el-option>
      </el-select>
      <el-input
        :placeholder="params.keywordType==1?'按订单号搜索':(params.keywordType==2?'按用户昵称搜索':(params.keywordType==3?'按患者名字搜索':(params.keywordType==4?'按分销员搜索':(params.keywordType==5?'按业务员名字搜索':(params.keywordType==6?'按收货人名字搜索':(params.keywordType==7?'按产品简称搜索':'请搜索'))))))"
        v-model="params.keyword" class="input-with-select">
        <el-button slot="append" icon="el-icon-search" @click="searchlist()"></el-button>
      </el-input>

      <el-select class="search-select" v-model="params.status" placeholder="按订单状态筛选" @change="searchlist">
        <el-option value="" label="全部" :key="0"></el-option>
        <el-option :value="0" label="待支付" :key="1"></el-option>
        <el-option :value="1" label="待发货" :key="2"></el-option>
        <el-option :value="2" label="待收货" :key="3"></el-option>
        <el-option :value="3" label="已完成" :key="4"></el-option>
        <el-option :value="4" label="已关闭" :key="5"></el-option>
        <el-option :value="7" label="手动取消" :key="6"></el-option>
      </el-select>
      <el-date-picker v-model="queryTime" type="daterange" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
        :default-time="['00:00:00', '23:59:59']" @change="dateChange">
      </el-date-picker>
      <el-button class="ml10" type="primary" @click="outexcel()">导出表格</el-button>
      <el-button class="ml10 importexcel mt10" type="primary"><input type="file" name="file"
          @change="uploadFile($event)"
          accept=".csv,application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />导入快递单号
      </el-button>
    </div>
    <!-- 列表 -->
    <!-- <el-table :data="list" stripe style="width: 100%" size="medium" v-if="0">
      <el-table-column prop="createTime" label="订单创建时间" width="150"></el-table-column>
      <el-table-column prop="creator" label="用户昵称" width="80"></el-table-column>
      <el-table-column prop="orderNum" label="购买次数" width="40"></el-table-column>
      <el-table-column prop="patientName" label="患者名字" width="80"></el-table-column>
      <el-table-column prop="patientPhone" label="联系电话" width="120"></el-table-column>
      <el-table-column prop="doctorName" label="医生名字" width="100"></el-table-column>
      <el-table-column prop="salesmanName" label="业务员名字" width="80"></el-table-column>
      <el-table-column prop="commodity" label="商品名称" width="150"></el-table-column>
      <el-table-column prop="specification" label="规格" width="80"></el-table-column>
      <el-table-column prop="quantity" label="数量" width="80"></el-table-column>
      <el-table-column prop="price" label="单价(元)" width="120"></el-table-column>
      <el-table-column prop="status" label="订单状态" width="100"></el-table-column>
      <el-table-column prop="payAmount" label="实付金额(元)" width="100"></el-table-column>
      <el-table-column prop="orderNumber" label="订单号" width="110"></el-table-column>
      <el-table-column prop="completeTime" label="完成时间" width="120"></el-table-column>
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="apply(scope.row.id)">查看订单详情</el-button>
          <el-button type="text" size="small" @click="showPickOrder(scope.row)" v-if="scope.row.status!='已完成'&&scope.row.status!='已关闭'&&scope.row.status!='已取消'">自提订单</el-button>
        </template>
      </el-table-column>
    </el-table> -->

    <div class="flex_c order-item" style="border: 1px solid #E2E2E2; border-radius: 8px;margin-top: 15px;"
      v-for="(item,index) in list">
      <div class="flex"
        style="justify-content: space-between;border-bottom: 1px solid #e2e2e2; flex: 1; padding: 12px 20px; background-color: #f4f4f4;">
        <div class="flex" style="font-size: 0.4rem;">
          <span v-if="item.creator">用户昵称：{{item.creator}}</span>
          <span style="margin-left: 20px;" v-if="item.patientName">患者名字：{{item.patientName}}</span>
          <span style="margin-left: 20px;" v-if="item.patientPhone">患者/家属电话：{{item.patientPhone}}</span>
          <span style="margin-left: 20px;" v-if="item.doctorName">医生：{{item.doctorName}}</span>
          <span style="margin-left: 20px;" v-if="item.salesmanName">业务员：{{item.salesmanName}}</span>
          <span style="margin-left: 20px;" v-if="item.sale">分销员：{{item.sale}}</span>
        </div>
        <div class="flex" style="font-size: 0.4rem;">
          <div class="flex" style="color: #666666;" v-if="item.status!='用户取消了订单'&&item.status!='已关闭'">
            <span>{{item.orderNum==1?'首单购物':'复购单'}}</span>
            <span style="margin-left: 10px;" v-if="item.orderNum>1">本单是第{{item.orderNum}}单</span>
          </div>
          <span style="margin-left: 15px; color: #fd3f31;">{{item.status}}</span>
        </div>
      </div>
      <div class="flex_c" style="padding:15px 20px;padding-bottom: 30px;">
        <div class="flex">
          <el-table :data="item.orderDetailList" stripe style="flex: 1;" size="medium" v-if="1"
            :span-method="spanMethod" border>
            <el-table-column prop="" label="订单收款(¥)" width="150">
              <template slot-scope="scope">
                <div style="text-align: center;">{{item.payAmount}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="shortName" label="产品简称" width="120"></el-table-column>
            <el-table-column prop="commodity" label="产品描述"></el-table-column>
            <el-table-column prop="specification" label="规格" width="100"></el-table-column>
            <el-table-column prop="price" label="单价(¥)" width="100"></el-table-column>
            <el-table-column prop="quantity" label="数量" width="60"></el-table-column>
            <el-table-column prop="promotionName" label="享受的优惠" width="100"></el-table-column>
          </el-table>
          <div style="margin-left: 30px; width: 120px;font-size: 0.4rem;">
            <div class="flex_c" v-if="item.status!='代付款'&&item.status!='已关闭'">
              <span class="flex-buttom" @click="inputDelivery(item)" v-if="item.status=='待发货'">录入发货信息</span>
              <!--    <span class="flex-buttom"
                v-if="item.divideStatus==0&&item.status=='待发货' || item.status=='待收货' || item.status=='已完成'"
                @click="divide(item.id)">手动分账</span> -->
              <span class="flex-buttom"
                v-if="item.status!='待支付'&&item.status!='已完成'&&item.status!='已关闭'&&item.status!='已取消'&&item.status!='用户取消了订单'&&item.status!='已完成（退款订单）'"
                @click="showPickOrder(item)">自提订单</span>
              <span v-if="item.status=='待确认'" class="flex-buttom" @click="sureget(item)">确认收款</span>
            </div>
          </div>
        </div>
        <div class="flex_c" v-if="item.pickUp==0" style="font-size: 0.4rem;">
          <div class="flex" style="margin-top: 16px;color: #666666;">
            <span v-if="item.contactPerson">收货人：{{item.contactPerson}}</span>
            <span style="margin-left: 15px;" v-if="item.contactPhone">联系电话：{{item.contactPhone}}</span>
            <span style="margin-left: 15px;" v-if="item.address">收货地址：{{item.address}}</span>
          </div>
          <div class="flex" style="margin-top: 10px; color: #666666;" v-if="item.status=='待收货'||item.status=='已完成'">
            <span>发货信息：{{item.expressCompany}} {{item.expressNumber}}</span>
          </div>
        </div>
        <div class="flex" style="margin-top: 16px;font-size: 0.4rem;" v-if="item.pickUp==1">
          <span>自提订单</span>
        </div>
        <div class="flex" style="color: #999999; font-size: 16px; margin-top: 10px;">
          <div class="flex" style="color: #999999; font-size: 16px; margin-top: 10px;">
            <span>创建订单时间：{{item.createTime}}</span>
            <span v-if="item.payTime&&item.status!='已关闭'&&item.status!='用户取消了订单'"
              style="margin-left: 20px;">付款时间：{{item.payTime}}</span>
            <span v-if="item.completeTime&&item.status!='已关闭'&&item.status!='用户取消了订单'"
              style="margin-left: 20px;">完成时间：{{item.completeTime}}</span>
            <span style="margin-left: 20px;" v-if="item.orderNumber">订单号：{{item.orderNumber}}</span>
            <span style="margin-left: 20px;" v-if="item.channelValue">订单渠道：{{item.channelValue}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="block pagination">
      <el-pagination :current-page.sync="info.pageNo" background @current-change="changepage"
        layout="prev, pager, next, jumper" :total="info.recordCount" :page-count="info.pageCount">
      </el-pagination>

    </div>

    <!-- 详情弹窗 -->
    <el-dialog title="订单详情" :visible.sync="outerVisible" top="8vh">
      <!-- 内容 -->
      <div class="orderdetail">
        <div class="box">
          <p>订单号：{{detail.orderNumber}}</p>
          <p>订单创建时间：{{detail.createTime}}</p>
          <p>用户昵称：{{detail.creator}}</p>
          <p>联系方式：{{detail.creatorMobile}}</p>
        </div>
        <div class="box">
          <p>购买商品：</p>
          <div class="shopinfobox flex">
            <el-image :preview-src-list="[GJ_BASEURL+detail.commodityPicture]"
              style="width: 40px; height:40px;background:#ccc;" :src="GJ_BASEURL+detail.commodityPicture"
              fit="scale-down">
              <div slot="error" class="flex ct imageerror" style="height:100%;">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div style="flex:1;padding-left:10px;">
              <div>{{detail.commodity}}<span style="padding-left:10px;">x {{detail.quantity}}</span></div>
              <div><span style="padding-right:10px;"
                  v-show="detail.specification">{{detail.specification}}</span>{{detail.price}}¥</div>
            </div>
          </div>
        </div>
        <div class="box">
          <p>商品金额：{{detail.amount}}¥</p>
          <p>运费：{{detail.freightFee}}¥</p>
          <p v-show="detail.promotionName">优惠：【{{detail.promotionName}}】<span
              v-show="detail.discountMoney">-{{detail.discountMoney}}¥</span></p>
          <p>订单总金额：{{detail.orderAmount}}¥</p>
          <p>订单状态：{{detail.status}}</p>
          <p>订单实付款：{{detail.payAmount}}¥</p>
        </div>
        <div class="box">
          <h4>快递信息</h4>
          <p>{{detail.contactPerson}} {{detail.contactPhone}}</p>
          <p>{{detail.region}} {{detail.address}}</p>
          <p>快递单号：{{detail.expressCompany}} {{detail.expressNumber}}</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outerVisible = false">关闭</el-button>
        <el-button type="primary" @click="innerVisible = true">编辑快递信息</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog title="快递信息" :visible.sync="innerVisible">
      <el-form ref="form" :model="form" label-width="120px" style="width:80%;">
        <el-form-item label="快递公司">
          <el-input v-model="form.expressCompany"></el-input>
        </el-form-item>
        <el-form-item label="快递单号">
          <el-input v-model="form.expressNumber"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="innerVisible = false">取消</el-button>
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog> -->

    <el-dialog title="录入发货信息" :visible.sync="innerVisible">
      <div class="flex_c">
        <div class="flex_c" style="padding-left: 12px;">
          <span class="flex">订单号：{{currentItem.orderNumber}}</span>
          <span class="flex" style="margin-top: 6px;">收货人：{{currentItem.contactPerson}}</span>
          <span class="flex" style="margin-top: 6px;">联系电话：{{currentItem.contactPhone}}</span>
          <span class="flex" style="margin-top: 6px;">收货地址：{{currentItem.address}}</span>
        </div>

        <el-form ref="form" :model="form" label-width="80px" style="width:80%;margin-top: 24px;">
          <el-form-item label="快递公司">
            <el-input v-model="form.expressCompany"></el-input>
          </el-form-item>
          <el-form-item label="快递单号">
            <el-input v-model="form.expressNumber"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="innerVisible = false">取消</el-button>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </div>

    </el-dialog>
    <el-dialog title="退款" :visible.sync="moneyVisible">
      <el-form ref="moneyform" label-width="120px" style="width:80%;">
        <el-form-item label="退款金额">
          <el-input v-model="outmoney" placeholder="金额不大于订单金额"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="moneySubmit">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="确认自提该订单？" :visible.sync="pickVisible" width="600px" class="i-exprot-dialog">

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="pickOrder">确 定</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
  import creator from '../../services/delevery/api-creator.js'
  const api = creator.create('/gj-api/pc')
  import {
    mapGetters,
    mapMutations
  } from 'vuex';
  export default {
    data() {
      return {
        list: [], // 表格数据
        info: {},
        detail: {},
        queryTime: '',
        params: {
          startTime: '', // 开始时间
          endTime: '', // 结束时间
          status: 1,
          keyword: '', //
          pageNo: 1, // 页码
          channel: 0,
          keywordType: '1',
          userType: 1 //后台要求，跟订单列表区分
        },
        form: {
          expressCompany: undefined,
          expressNumber: undefined,
        },
        outerVisible: false,
        innerVisible: false,
        moneyVisible: false,
        outmoney: "", //退款金额
        pickVisible: false,
        currentItem: {}
      }
    },
    computed: {
      ...mapGetters([
        'user',
        'GJ_BASEURL'
      ])
    },
    created() {
      // 获取列表数据
      this.getList();
    },
    methods: {
      inputDelivery(item) {
        this.currentItem = item
        this.innerVisible = true
      },
      spanMethod({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        if (columnIndex === 0 || columnIndex === 1) {
          if (rowIndex % row.spanSize === 0 || rowIndex % row.spanSize === 1) {
            return {
              rowspan: row.spanSize,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      },
      getList(pageNo = 1) {
        this.params.pageNo = pageNo
        api.getList(this.params).then((res) => {
          this.info = res.data;
          this.list = res.data.list;
        })
      },
      // 选择日期获取新列表
      dateChange() {
        this.params.startTime = this.queryTime[0];
        this.params.endTime = this.queryTime[1];
        this.searchlist();
      },
      // 页码改变时更新列表
      changepage(val) {
        this.getList(val);
      },
      getInfo(id, cal) {
        api.getDetail({
          id
        }).then(res => {
          console.log("detail", res)
          this.detail = res.data;
          this.form.expressCompany = res.data.expressCompany || undefined;
          this.form.expressNumber = res.data.expressNumber || undefined;
          if (cal) cal();
        })
      },
      searchlist(val) {
        this.params.pageNo = 1;
        this.getList();
      },

      //查看
      apply(id) {
        this.getInfo(id, () => {
          this.outerVisible = true;
        });
        this.form.id = id;
      },
      //手动分账
      divide(id) {
        this.$router.push({
          path: "/order/divideSupply",
          query: {
            id: id
          }
        });
      },
      markback() {
        this.outmoney = "";
        this.moneyVisible = true;
      },
      moneySubmit() { //退款
        if (this.outmoney > this.detail.payAmount) {
          this.$message.info("金额有误");
          return;
        }
        api.mark({
          id: this.form.id,
          outmoney: this.outmoney
        }).then(rs => {
          if (rs.status == 1) {
            this.$message({
              message: rs.msg,
              type: 'success'
            });
            this.moneyVisible = false;
            this.getInfo(this.form.id);
          } else {
            this.$message(rs.msg);
          }
        })
      },
      //保存
      onSubmit(dialogForm) {
        this.form.id = this.currentItem.id
        api.save({
          ...this.form
        }).then(rs => {
          if (rs.status == 1) {
            this.$message({
              message: rs.msg,
              type: 'success'
            });
            this.getList();
            this.innerVisible = false;
            // setTimeout(() => {
            //   this.getInfo(this.form.id);
            //   this.innerVisible = false;
            //   this.form = {
            //     expressCompany: undefined,
            //     expressNumber: undefined,
            //   };
            // }, 600)
          } else {
            this.$message(rs.msg);
          }
        })
      },

      //导出excel
      outexcel() {
        api.outexcel(this.params).then(res => {
          // console.log(rs)
          this.saveexcel(res);
        })
      },
      saveexcel(res) {
        const link = document.createElement("a");
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel"
        });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI("订单记录表"));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      // 前端实现导出表格
      outportData() {
        require.ensure([], () => {
          const {
            export_json_to_excel
          } = require('@/vendor/Export2Excel.js'); //引入文件　　　　
          const tHeader = ['订单号', '用户昵称', '商品名称', '数量', '单价（元）', '订单状态', '实付金额（元）', '分享员', '订单创建时间', '完成时间']; //表头
          const filterVal = ['orderNumber', 'creator', 'commodity', 'quantity', 'price', 'status', 'payAmount',
            'sale', 'createTime', 'completeTime'
          ]; //table表格中对应的属性名　　　　　
          const data = this.formatJson(filterVal, this.list); //表格绑定数据positionData转json　　
          const fileName = "订单记录表";
          export_json_to_excel(tHeader, data, fileName);
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },
      uploadFile(e) {
        let file = e.target.files[0];
        if (!file) return;
        let param = new FormData(); //创建form对象
        param.append('excelFile', file); //通过append向form对象添加数据
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }; //添加请求头
        api.inexcel(param, config).then(rs => {
          this.getList();
          this.$message.success(rs.msg);
        })
      },
      //自提订单
      showPickOrder(item) {
        this.pickVisible = true
        this.pickInfo = item
      },
      pickOrder() {
        if (this.pickInfo.id) {
          api.takeOrder({
            id: this.pickInfo.id
          }).then((res) => {
            this.pickVisible = false
            this.getList()
          })
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "index.scss";
  $main-color:#409eff;

  .order-item {
    .flex-buttom {
      color: $main-color;
      display: flex;
      margin-top: 10px;
      cursor: pointer;
    }

    .inline-buttom {
      color: $main-color;
      display: inline-block;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/delivery/gj-delivery-list.vue